<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Remote Access Details</template>
            <!-- Data -->
            <template slot="data">
                <div class="row" v-if="retrieved">
                    <div class="col">
                        <div class="row pt-2">
                            <div class="col-lg-6 drop">
                                <div class="sau-bx p-6 h-100">
                                    <h5>Username</h5>
                                    <p v-if="accessUsername">{{ accessUsername }}</p>
                                    <p v-else>Not Set</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="sau-bx p-6 h-100">
                                    <h5>Password</h5>
                                    <div v-show="!showAccessPassword">
                                        <!-- Match the dots to the password length -->
                                        <template v-if="accessPassword">
                                            <span class="sau-pwd-dot space" v-for="(key, index) in accessPassword.length" :key="index"></span>
                                            <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Show</a> / <b-link href="#" v-b-modal.modalChangePassword class="sau-linx green sau-font sm">Change</b-link>
                                        </template>
                                        <template v-else>
                                            <p>Not Set</p>
                                        </template>
                                    </div>
                                    <div v-show="showAccessPassword">
                                        <span class="clear-password wm-hide">{{ accessPassword }}</span>
                                        <a href="#" class="sau-linx green sau-font sm pl-2" @click.prevent="showAccessPassword = !showAccessPassword">Hide</a>
                                    </div>

                                    <!-- change Password -->
                                    <b-modal id="modalChangePassword"
                                        centered
                                        title="Change Your Password"
                                        @ok="changePassword"
                                        @cancel="clearDetails"
                                        :ok-variant="btnColor"
                                        :ok-disabled="disableOk"
                                        ok-title="Change Password"
                                        cancel-variant="link">
                                        <form>
                                            <div class="row">
                                                <div class="col-sm-12 col-lg-6 offset-lg-3">
                                                    <!-- New Password -->
                                                    <div class="form-group">
                                                        <label for="newPassword">Enter New Password</label>
                                                        <input type="text"
                                                            name="newPassword"
                                                            v-model="newPassword"
                                                            class="form-control"
                                                            v-on:input="$v.newPassword.$touch"
                                                            :class="{'is-invalid': $v.newPassword.$invalid && $v.newPassword.$dirty, 'is-valid': !$v.newPassword.$invalid && $v.newPassword.$dirty}" />
                                                        <!-- New Password Validations -->
                                                        <!-- Validations -->
                                                        <div v-show="!$v.newPassword.$dirty">
                                                            <small class="text-muted">* Required</small>
                                                        </div><!-- default message -->
                                                        <div v-show="!$v.newPassword.$invalid">&nbsp;</div><!-- valid message -->
                                                        <div v-if="!$v.newPassword.required" class="invalid-feedback">* Required</div>
                                                    </div>
                                                    <!-- Re-enter Password -->
                                                    <div class="form-group">
                                                        <label for="reEnterPassword">Re-enter Password</label>
                                                        <input type="text"
                                                            name="reEnterPassword"
                                                            v-model="reEnterPassword"
                                                            class="form-control"
                                                            v-on:input="$v.reEnterPassword.$touch"
                                                            :class="{'is-invalid': $v.reEnterPassword.$invalid && $v.reEnterPassword.$dirty, 'is-valid': !$v.reEnterPassword.$invalid && $v.reEnterPassword.$dirty}" />
                                                        <!-- Validations -->
                                                        <div v-show="!$v.reEnterPassword.$dirty">
                                                            <small class="text-muted">&nbsp;</small>
                                                        </div><!-- default message -->
                                                        <div v-show="!$v.reEnterPassword.$invalid">&nbsp;</div><!-- valid message -->
                                                        <div v-if="!$v.reEnterPassword.required" class="invalid-feedback">Passwords must match</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </b-modal>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col">

                        <sau-apiro-response type="error" support="true">
                            <template slot="message">There was an issue retrieving your login details.</template>
                            <template slot="details">
                                <p>For more information please contact our Support Team.</p>
                            </template>
                        </sau-apiro-response>

                    </div>
                </div>
            </template>

        </sau-template>
    </div>
</template>
<script>
import Vuelidate from 'vuelidate';
import { required, sameAs, minLength} from 'vuelidate/lib/validators';
export default {
    data() {
        return {
            showAccessPassword: false,
            retrieved: false,
            accessPassword: '',
            accessUsername: '',
            btnColor:'success',
            error:{
                message:''
            },
            newPassword:'',
            reEnterPassword:'',
            id: ''
        }
    },
    validations:{
        newPassword:{
            required
        },
        reEnterPassword:{
            sameAsPassword: sameAs('newPassword')
        }
    },
    created() {
        this.startApp();
    },
    computed: {
        disableOk() {
            if(!this.$v.$invalid) {
                this.btnColor = 'success'
                return false;
            } else {
                this.btnColor = 'light'
                return true;
            }
        },
    },
    methods: {
        startApp() {
            this.getLoginDetails().then(response => {
                if(response.data) {
                    this.accessUsername = response.data.username;
                    this.accessPassword = response.data.password;
                }
                this.retrieved = true;
            });
        },
        changePassword() {
            let data = {
                password: this.newPassword,
                confirm: this.reEnterPassword
            }
            this.updateHostPassword(data).then(response => {
                this.clearDetails();
                if(response.data.status == 'success') {
                    this.$swal({
                        type:'success',
                        title: 'Your password has been updated',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.accessPassword = data.password;
                }
            })
            .catch(error => {
                let message = '';
                _.forIn(error.response.data.errors, function(value, key) {
                    message += value+'<br />';
                });
                this.$swal({
                    type:'error',
                    title: 'There was an issue updating your password',
                    html: message,
                    showConfirmButton: false,
                });
            });
        },
        clearDetails() {
            this.newPassword = this.reEnterPassword  = '';
            this.$v.$reset();
        }
    }
}
</script>
<style>
.space {
    margin:0px 2px;
}
</style>
